import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ToolsPage from "./pages/ToolsPage";
import ProductPage from "./pages/ProductPage";
import PrivacyPage from "./pages/PrivacyPage";
import ContactPage from "./pages/ContactPage";
import MarginMatePrivacyPage from "./pages/MarginMatePrivacyPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tools" element={<ToolsPage />} />
            <Route path="/epic" element={<ProductPage slug="epic" />} />
            <Route path="/fork" element={<ProductPage slug="fork" />} />
            <Route path="/snapstax" element={<ProductPage slug="snapstax" />} />
            <Route path="/marginmate" element={<ProductPage slug="marginmate" />} />
            <Route path="/marginmate/privacy" element={<MarginMatePrivacyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
